import { CommonListParams, PipeReview } from 'types/common';
import { AxiosResponse, AxiosResponseHeaders } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { API } from 'network/api';
import { useMemo } from 'react';

type Params = CommonListParams & {
  seasonId?: string;
  country?: string;
  task?: string;
  status?: string;
  farmerGroup?: string;
};

const usePipeListQuery = (params?: Params) => {
  const queryParams = useMemo(
    () => ({
      projection: 'MrvResourcesListWithCubeAndTask',
      distinct: false,
      sort: 'updated_at,desc',
      'country.equals': params?.country,
      'seasonTypeId.equals': params?.seasonId,
      page: params?.page ? params.page - 1 : undefined,
      size: params?.size,
      'taskType.equals':
        params?.task && params.task !== 'Drying Event'
          ? params.task
          : undefined,
      'taskType.in':
        params?.task && params.task === 'Drying Event'
          ? 'Drying Event,Drying Event 1'
          : undefined,
      'status.in': params?.status,
      'cubeName.equals': params?.farmerGroup,
    }),
    [params],
  );
  const query = useQuery<AxiosResponse<PipeReview[]>>({
    queryKey: ['pipe-list', queryParams],
    queryFn: () => API.get('/mrvresources/review', { params: queryParams }),
  });

  const headers = query?.data?.headers as AxiosResponseHeaders;
  const totalCount = Number(headers?.get('X-Total-Count')) || 0;

  return { ...query, totalCount };
};

export default usePipeListQuery;
